import type { ReactNode } from "react";
import { Nothing } from "~/components/permission/Nothing";

export type ToDoProps = {
    until: string;
    children?: ReactNode;
};

export const ToDo = (_props: ToDoProps) => {
    return <Nothing />;
};
